import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusColor'
})
export class StatusColorPipe implements PipeTransform {

  transform(statusCode: string): string {
    if (!statusCode) return 'default';
    
    const status = statusCode.toLowerCase();
    
    if (status.includes('inactive') || status.includes('failed') || status.includes('in-active') || status.includes('in_active') || status.includes('reject') || status.includes('rejected') || status.includes('cancel') || status.includes('cancelled') || status.includes('expired') || status.includes('deactive')) {      
      return 'red';
    } else if (status.includes('approve') ||status.includes('success') || status.includes('active') || status.includes('approved') || status.includes('completed')) {
      return 'green';
    } else if (status.includes('pending') ||status.includes('partially') ||  status.includes('review') || status.includes('draft') || status.includes('sandboxing') || status.includes('re-sandboxing') || status.includes('progress')) {   
      return 'orange';
    } else if (status.includes('suspend')) {
      return 'volcano';
    }
    
    return 'default';
  }
}